import React from 'react';
import useReveal from '../hooks/useReveal';
import useSeo from '../hooks/useSeo';
import StatsSection from '../components/StatsSection';
import CalculatorSection from '../components/CalculatorSection';
import PerformanceIntelligence from '../components/PerformanceIntelligence';
import DashboardDemo from '../components/DashboardDemo';
import GlobalGrowth from '../components/GlobalGrowth';
import TechnologySection from '../components/TechnologySection';
import IntegrationsSection from '../components/IntegrationsSection';
import CTA from '../components/CTA';

export default function Performance() {
  useReveal('performance');
  useSeo({ title: 'Performance & Intelligence | Interscope Ads', description: 'Turning media spend into measurable growth. Real-time performance intelligence, funnel optimization and transparent dashboards.' });
  return (
    <main className="pt-32">
      <section className="relative max-w-7xl mx-auto px-5 md:px-8 pb-6 text-center">
        <span className="reveal inline-block mb-3 text-xs font-semibold tracking-[0.25em] uppercase text-[#2563eb]">Performance</span>
        <h1 className="reveal font-display text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.08] max-w-3xl mx-auto">
          Turning Media Spend Into <span className="text-gradient">Measurable Growth</span>
        </h1>
        <p className="reveal mt-6 text-slate-600 text-lg max-w-2xl mx-auto">
          Every rupee is tracked to an outcome. Explore how we measure, optimize and scale performance in real time.
        </p>
      </section>

      <StatsSection />
      <CalculatorSection />
      <PerformanceIntelligence />
      <DashboardDemo />
      <GlobalGrowth />
      <TechnologySection />
      <IntegrationsSection />
      <CTA />
    </main>
  );
}
